import { render, staticRenderFns } from "./ProductConfig.vue?vue&type=template&id=902e4732&"
import script from "./ProductConfig.vue?vue&type=script&lang=ts&"
export * from "./ProductConfig.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports